@if (hasContent()) {
    <section class="fl" [attr.aria-labelledby]="title() ? headingId : null" data-cy="featured-links-side-nav">
        <div class="fl__inner" [class.fl__inner--no-nav]="!hasSideNav()">
            <div class="fl__main">
                @if (title(); as heading) {
                    <h2 class="fl__title" [id]="headingId" data-cy="title">{{ heading }}</h2>
                }
                @if (introHtml(); as intro) {
                    <div class="fl__intro" [innerHTML]="intro" data-cy="intro"></div>
                }
                @if (noticeHtml(); as notice) {
                    <p class="fl__notice" [innerHTML]="notice" data-cy="notice"></p>
                }
                @if (items().length) {
                    <ul class="fl__rows">
                        @for (item of items(); track $index) {
                            <li
                                class="fl__row"
                                [class.fl__row--no-image]="!item.image"
                                [class.fl__row--linked]="!!item.link"
                                data-cy="row">
                                @if (item.image; as image) {
                                    <div class="fl__media">
                                        <sirius-image-item
                                            class="fl__photo"
                                            [image]="image"
                                            [imageData]="rowPhoto"
                                            [alt]="image.title"
                                            objectFit="cover" />
                                    </div>
                                }
                                <div class="fl__body">
                                    <h3 class="fl__heading" data-cy="heading">{{ item.title }}</h3>
                                    @if (item.descriptionHtml; as description) {
                                        <div
                                            class="fl__description"
                                            [innerHTML]="description"
                                            data-cy="description"></div>
                                    }
                                    @if (item.link; as link) {
                                        <a class="fl__cta" [siriusLink]="link" data-cy="cta">
                                            {{ link.title }}<span class="fl__cta-context">: {{ item.title }}</span>
                                            <sirius-icon name="arrow_right_small" aria-hidden="true" />
                                        </a>
                                    }
                                </div>
                            </li>
                        }
                    </ul>
                }
            </div>
            @if (hasSideNav()) {
                <nav class="fl__nav" [attr.aria-labelledby]="sideNavTitle() ? navHeadingId : null" data-cy="side-nav">
                    @if (sideNavTitle(); as navTitle) {
                        <h3 class="fl__nav-title" [id]="navHeadingId" data-cy="side-nav-title">{{ navTitle }}</h3>
                    }
                    <ul class="fl__nav-list">
                        @for (link of sideNavLinks(); track $index) {
                            <li>
                                <a class="fl__nav-link" [siriusLink]="link" data-cy="side-nav-link">
                                    {{ link.title }}
                                    <sirius-icon name="arrow_right_small" aria-hidden="true" />
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            }
        </div>
    </section>
}
